//create and update.tsx
import React, { SetStateAction, useEffect, useRef, useState } from "react";
import Close from "../../assets/Modal-Close-Icon.svg";
import "../popup-main.css";
import "./createPopup.css";
import Drop from "../../assets/Polygon 2.svg";
import attach from "../../assets/Attach.svg";
import CrossClose from "../../assets/CrossClose.svg";
import Negative from "../../assets/VectorERROR.svg";
import Positive from "../../assets/VectorPASS.svg";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux-store/store";
import FloatingLabelDatePicker from "./FloatingLabelDatePicker";
import {
  CreateNotification,
  GetAllNotification_M3,
  UpdateNotification,
} from "../../../../api/notifyapi/Notifyapi";

import dayjs, { Dayjs } from "dayjs";
import {
  DEFAULT_INPUT_VALUES,
  ERROR_MESSAGES,
  initializeInputValues,
  InputValues,
  prepareNotificationData,
  validateInput,
  VALIDATION_RULES,
} from "./FormDataConstants";
import Loader from "../../loader/Loader";
import { IFilterModel } from "../../../../slices/NotificationSlice";
import { CATEGORY_FILTER_OPTIONS } from "../CloumnFilter/ExtensiveFilterContent";
import { InputField } from "./InputContant";

interface Props {
  isCreateClose: React.Dispatch<SetStateAction<boolean>>;
  isUpdateClose: React.Dispatch<SetStateAction<boolean>>;
  EnableCreate: boolean;
}
export interface LevelItems {
  label: string;
  value: string;
}
interface FileData {
  fileName: string;
  copiedPath: string;
  uploadTime: string;
}

const levelItems: LevelItems[] = [
  { label: "Level 1", value: "LEVEL_1" },
  { label: "Level 2", value: "LEVEL_2" },
];

const CreateAndUpdate: React.FC<Props> = ({
  isCreateClose,
  isUpdateClose,
  EnableCreate,
}) => {
  const resources = useSelector(
    (state: RootState) => state.userControl.NotificationTarget.TargetResource
  );
  const user = useSelector((state: RootState) => state.user.user);
  const updatedData = useSelector(
    (state: RootState) => state.notification.editData
  );
  const { searchFilter } = useSelector(
    (state: RootState) => state.notification
  );
  const dispatch = useDispatch<AppDispatch>();
  const [inputValues, setInputValues] =
    useState<InputValues>(DEFAULT_INPUT_VALUES);
  const [isLevelDropOpen, setIsLevelDropOpen] = useState(false);
  const [isCategoryDropOpen, setIsCategoryDropOpen] = useState(false);
  const [selectedTarget, setSelectedTarget] = useState<string>("");
  const [isTargetDropOpen, setIsTargetDropOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [allFiles, setAllFiles] = useState<File[]>([]);
  const [fileNames, setFileNames] = useState<string[]>([]);
  const [newFiles, setNewFiles] = useState<(FileData | File)[]>([]);
  const [filesToRemove, setFilesToRemove] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [fileError, setFileError] = useState<boolean>(false);
  const [fileErrorMsg, setFileErrorMsg] = useState<string>("");

  // define the create and edit method

  useEffect(() => {
    if (!EnableCreate && updatedData) {
      const initializedValues = initializeInputValues(updatedData);
      setInputValues(initializedValues);

      if (Array.isArray(updatedData.target)) {
        setSelectedTarget(updatedData.target.join(", "));
      }

      setNewFiles(
        Array.isArray(updatedData.attachments) ? updatedData.attachments : []
      );
    }
  }, [EnableCreate, updatedData]);

  // handle the function of input value changes
  const handleChanges = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    const { name, value } = e.target;

    if (name in DEFAULT_INPUT_VALUES) {
      setInputValues((prevValues) => ({
        ...prevValues,
        [name]: {
          value: value,
          showError:
            !value ||
            (name === "title" &&
              value.length < VALIDATION_RULES.TITLE_MIN_LENGTH),
          errorMsg: getErrorMessage(name, value),
        },
      }));
    }
  };

  // Helper function to get specific error messages
  const getErrorMessage = (fieldName: string, value: string): string | null => {
    if (!value) {
      return ERROR_MESSAGES[
        fieldName.toUpperCase() as keyof typeof ERROR_MESSAGES
      ];
    }

    // Special validation for title length
    if (
      fieldName === "title" &&
      value.length < VALIDATION_RULES.TITLE_MIN_LENGTH
    ) {
      return ERROR_MESSAGES.TITLE;
    }

    return null;
  };

  // handle effective date changes
  const handleEffectiveDateChange = (date: Dayjs): void => {
    if (date) {
      const formattedDate = date.format("YYYY-MM-DDTHH:mm:ss");
      setInputValues((prevValues) => ({
        ...prevValues,
        effectiveDate: {
          value: formattedDate,
          showError: !formattedDate,
          errorMsg: !formattedDate ? ERROR_MESSAGES.EFFECTIVE_DATE : null,
        },
      }));
    } else {
      setInputValues((prevValues) => ({
        ...prevValues,
        effectiveDate: {
          value: "",
          showError: true,
          errorMsg: ERROR_MESSAGES.EFFECTIVE_DATE,
        },
      }));
      setInputValues((prevValues) => ({
        ...prevValues,
        expirationDate: {
          value: "",
          showError: false,
          errorMsg: null,
        },
      }));
    }
  };

  // handle effective date changes
  const handleExpirationDateChange = (date: Dayjs | null): void => {
    if (date) {
      const formattedDate = date.format("YYYY-MM-DDTHH:mm:ss");

      setInputValues((prevValues) => ({
        ...prevValues,
        expirationDate: {
          value: formattedDate,
          showError: !formattedDate,
          errorMsg: !formattedDate ? ERROR_MESSAGES.EXPIRATION_DATE : null,
        },
      }));
    } else {
      setInputValues((prevValues) => ({
        ...prevValues,
        expirationDate: {
          value: "",
          showError: true,
          errorMsg: ERROR_MESSAGES.EXPIRATION_DATE,
        },
      }));
    }
  };

  // Function to Toggle the level input
  const handleToggle = () => {
    setIsLevelDropOpen(!isLevelDropOpen);
  };

  // Funtion to Toggle the category input
  const toggleCategory = () => {
    setIsCategoryDropOpen(!isCategoryDropOpen);
  };

  // Funtion to Toggle the Target input
  const handleTarget = () => {
    setIsTargetDropOpen(!isTargetDropOpen);
  };

  // Trigger file input click
  const handleAttachClick = () => {
    document.getElementById("fileInput")?.click();
  };

  //Funtion to handle LevelInput value Changes
  const handleLevelChanges = (label: string) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      level: {
        value: label || "",
        showError: !label,
        errorMsg: !label ? ERROR_MESSAGES.LEVEL : null,
      },
    }));
    setIsLevelDropOpen(!isLevelDropOpen);
  };

  //Funtion to handle Category value changes
  const handlecategoryChanges = (label: string) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      category: {
        value: label || "",
        showError: !label,
        errorMsg: !label ? ERROR_MESSAGES.CATEGORY : null,
      },
    }));
    if (label !== "TARGET") {
      setInputValues((prevValues) => ({
        ...prevValues,
        target: {
          value: [],
          showError: false,
          errorMsg: "",
        },
      }));
      setSelectedTarget("");
    }
    setIsCategoryDropOpen(false);
  };

  // Function to Hadle checkbox changes
  const handleTargetCheckboxChange = (value: string) => {
    let updatedTargets;
    // Toggle the checkbox value
    if (inputValues.target.value.includes(value)) {
      updatedTargets = inputValues.target.value.filter(
        (item: string) => item !== value
      ); // Remove the target
    } else {
      updatedTargets = [...inputValues.target.value, value]; // Add the target
    }
    // Update the inputValues and selectedTarget states
    setInputValues({
      ...inputValues,
      target: {
        value: updatedTargets,
        showError: updatedTargets.length === 0,
        errorMsg: updatedTargets.length === 0 ? ERROR_MESSAGES.TARGET : "",
      },
    });
    setSelectedTarget(updatedTargets.join(", ")); // Convert to comma-separated string
  };

  // outFocus close on target dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        event.target instanceof Node &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsTargetDropOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //Handle upload mulitiple file as formdata for create and Update Both
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const files = Array.from(event.target.files);
      const maxSize = 10 * 1024 * 1024; // 10 MB
      const newFiles: File[] = [];
      const largeFiles: string[] = [];

      files.forEach((file) => {
        if (file.size > maxSize) {
          largeFiles.push(file.name);
        } else {
          newFiles.push(file);
        }
      });

      if (largeFiles.length > 0) {
        // Handle error: some files are too large
        setFileError(true); // Assuming you have a state for file error
        setFileErrorMsg(
          `The following files exceed the 10 MB size limit: ${largeFiles.join(
            ", "
          )}`
        );
      } else {
        setFileError(false);
      }

      if (newFiles.length > 0) {
        const formattedFiles = newFiles.map((file) => ({
          file,
          fileName: file.name,
        }));

        if (EnableCreate) {
          setAllFiles((prevFiles) => [...prevFiles, ...newFiles]);
          setFileNames((prevFileNames) => [
            ...prevFileNames,
            ...newFiles.map((file) => file.name),
          ]);
        } else {
          setNewFiles((prevFiles) => [...prevFiles, ...newFiles]);
          setFileNames((prevFileNames) => [
            ...prevFileNames,
            ...formattedFiles.map((f) => f.fileName),
          ]);
        }
      }
    }
  };

  // Modified handleremoveFile to properly handle file removal
  const handleRemoveFile = (fileName: string) => {
    if (EnableCreate) {
      setAllFiles((prevFiles) =>
        prevFiles.filter((file) => file.name !== fileName)
      );
      setFileNames((prevFileNames) =>
        prevFileNames.filter((name) => name !== fileName)
      );
    } else {
      const updateNewFile = newFiles.filter(
        (item: any) => (item.fileName || item.name) !== fileName
      );
      setNewFiles(updateNewFile);
    }
    setFilesToRemove((prevFiles) => [...prevFiles, fileName]);
  };

  //Handle close the popup form
  const handleModalClose = (): void => {
    isCreateClose(false);
    isUpdateClose(false);
    setInputValues(DEFAULT_INPUT_VALUES);
  };

  //Form Validation
  const validateForm = (): boolean => {
    const { isValid, updatedValues } = validateInput(inputValues);
    setInputValues(updatedValues);
    return isValid;
  };

  // handle create New notification function
  const handleSubmit = async (): Promise<void> => {
    if (validateForm()) {
      setIsLoading(true);
      try {
        const formData = new FormData();

        // Append new files (for both create and update)
        if (EnableCreate) {
          allFiles.forEach((file) => {
            formData.append("files", file);
          });
        } else {
          newFiles.forEach((file: any) => {
            formData.append("files", file);
          });
        }

        const notificationData = prepareNotificationData(
          inputValues,
          user?.email || ""
        );

        if (EnableCreate && user) {
          await dispatch(
            CreateNotification({
              ...notificationData,
              file: formData,
            })
          ).then(() => {
            dispatch(GetAllNotification_M3(searchFilter.apiQuery));
          });
        } else {
          await dispatch(
            UpdateNotification({
              notificationId: updatedData?.notificationID || "",
              notification: notificationData,
              file: formData,
              RemoveFile: filesToRemove,
            })
          ).then(() => {
            if (searchFilter.globalSearch.value) {
              let lQuery: IFilterModel = {
                filters: searchFilter.globalSearchApiQuery.filters,
                isAscending: false,
                currentPageSize: searchFilter.apiQuery.currentPageSize,
                pageSize: searchFilter.apiQuery.pageSize,
                page: 1, //First time always get page 1
                isOr: true,
                isPageChanged: "",
                sortField: "",
              };

              dispatch(GetAllNotification_M3(lQuery));
            } else {
              dispatch(GetAllNotification_M3(searchFilter.apiQuery));
            }
          });
        }
        handleModalClose();
        setIsLoading(false);
      } catch (error) {}
    }
  };

  // Tittle Error Css handler
  const renderTitleErrorIndicator = (
    <div className="title-validation">
      <img
        src={inputValues.title.value.length >= 10 ? Positive : Negative}
        alt="validation-icon"
        className="error-icon"
      />
    </div>
  );

  const renderClassName = `input-container ${
    inputValues.title.value.length >= 10 ? "" : "validation-error-input"
  }`;
  const renderIndicatorClassName = `title-validation ${
    inputValues.title.value.length >= 10 ? "" : "title-error-indicator"
  }`;

  return (
    <div className="modal-overlay">
      <div className="modal-content create">
        <div className="modal-header">
          <div className="popup-head">
            {EnableCreate ? "Create Notification" : "Edit Notification"}
          </div>
          <img
            src={Close}
            alt="close-icon"
            className="close-btn"
            tabIndex={0}
            onClick={handleModalClose}
          />
        </div>
        <div className="create-content-main">
          <div className="modal-body create-body">
            <div
              className={
                inputValues.title.value.length > 0
                  ? renderClassName
                  : "input-container"
              }
            >
              <div className="input-subContainer">
                <label className="label-element">
                  Title<span className="span-element">*</span>
                </label>
                <div className="title-input-container">
                  <input
                    type="text"
                    name="title"
                    value={inputValues.title.value}
                    className="modal-input-element"
                    placeholder="Enter Title...."
                    onChange={(e) => handleChanges(e)}
                  />
                  <div>
                    {inputValues.title.value.length > 0 &&
                      renderTitleErrorIndicator}
                  </div>
                </div>
              </div>
              <div
                className={
                  inputValues.title.value.length > 0
                    ? renderIndicatorClassName
                    : "title-validation"
                }
              >
                A minimum of 10 characters required
              </div>
            </div>
            <div
              className={`input-container ${
                inputValues.description.showError
                  ? " validation-error-input"
                  : ""
              }`}
              style={{ height: "auto", textWrap: "wrap" }}
            >
              <div className="input-subContainer description-input">
                <label className="label-element">
                  Description<span className="span-element">*</span>
                </label>
                <textarea
                  className="modal-input-element"
                  name="description"
                  placeholder="Enter Description..."
                  value={inputValues.description.value}
                  onChange={(e) => handleChanges(e)}
                  style={{
                    height: "55px",
                    paddingRight: "10px",
                    resize: "none",
                  }}
                />
              </div>
            </div>
            {inputValues.description.showError && (
              <div className="error-msg">
                {inputValues.description.errorMsg}
              </div>
            )}
            <div
              className={`input-container ${
                inputValues.level.showError ? " validation-error-input" : ""
              }`}
            >
              <div className="input-subContainer">
                <label className="label-element">
                  Level<span className="span-element">*</span>
                </label>
                <div className="dropdow-input-container" onClick={handleToggle}>
                  <span className="dropdown-spanElement">
                    {inputValues.level.value !== ""
                      ? inputValues.level.value
                      : "Select Level"}
                  </span>
                  <img
                    src={Drop}
                    alt=""
                    style={{
                      cursor: "pointer",
                      position: "relative",
                      left: "9px",
                    }}
                  />
                </div>
                {isLevelDropOpen && (
                  <div className="level-dropdow-container">
                    {levelItems.map((item) => (
                      <div
                        className="dropdownList-container"
                        onClick={() => handleLevelChanges(`${item.value}`)}
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {inputValues.level.showError && (
              <div className="error-msg">{inputValues.level.errorMsg}</div>
            )}
            <div className="combained-container">
              <div
                className={`input-container ${
                  inputValues.category.showError
                    ? " validation-error-input"
                    : ""
                }`}
              >
                <div className="input-subContainer">
                  <label className="label-element">
                    Category<span className="span-element">*</span>
                  </label>
                  <div
                    className="dropdow-input-container"
                    onClick={toggleCategory}
                  >
                    <span className="dropdown-spanElement">
                      {inputValues.category.value !== ""
                        ? inputValues.category.value
                        : "Select Category"}
                    </span>
                    <img
                      src={Drop}
                      alt=""
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        right: "-9px",
                      }}
                    />
                  </div>
                </div>
                {isCategoryDropOpen && (
                  <div className="category-dropDown-container">
                    {CATEGORY_FILTER_OPTIONS.map((item: LevelItems) => (
                      <div
                        className="dropdownList-container"
                        onClick={() => handlecategoryChanges(`${item.value}`)}
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                )}
                {inputValues.category.showError && (
                  <div
                    className="error-msg"
                    style={{ top: "12px", left: "6px" }}
                  >
                    {inputValues.category.errorMsg}
                  </div>
                )}
              </div>
              {inputValues.category.value === "TARGET" ? (
                <div
                  className={
                    inputValues.target.showError
                      ? renderClassName
                      : "input-container target-input"
                  }
                >
                  <div
                    className={`input-subContainer ${
                      inputValues.target.showError
                        ? " validation-error-input"
                        : ""
                    }`}
                    ref={dropdownRef}
                  >
                    <label className="label-element">
                      Target<span className="span-element">*</span>
                    </label>
                    <div
                      className="dropdow-input-container"
                      onClick={handleTarget}
                    >
                      <span className="dropdown-spanElement">
                        {" "}
                        {inputValues.target.value.length === 0
                          ? "Select Target"
                          : selectedTarget.slice(0, 20)}
                        ...
                      </span>
                      <img
                        src={Drop}
                        alt=""
                        style={{
                          cursor: "pointer",
                          marginRight: "-11px",
                          marginTop: "7px",
                        }}
                      />
                    </div>
                    {isTargetDropOpen && (
                      <div
                        className="category-dropDown-container"
                        style={{ height: "120px" }}
                      >
                        {resources.map((item: any, index: number) => (
                          <div className="dropdownList-container">
                            <div className="target-checkbox-list-container">
                              <input
                                type="checkbox"
                                id={`${index}`}
                                className="checkbox-input"
                                checked={inputValues.target.value.includes(
                                  item.value
                                )}
                                onChange={() =>
                                  handleTargetCheckboxChange(item.value)
                                }
                              />
                              <label
                                htmlFor={`${index}`}
                                className="dropdown-spanElement"
                              >
                                {item.label}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            {inputValues.target.showError && (
              <div className="error-msg target-err">
                {inputValues.target.errorMsg}
              </div>
            )}
            <div className="date-main-container">
              <div
                className={`date-sub-container ${
                  inputValues.effectiveDate.showError
                    ? " validation-error-input"
                    : ""
                }`}
              >
                <div className="input-subContainer">
                  <div
                    className="label-element"
                    style={{ padding: "8px 0 0 10px" }}
                  >
                    Effective Date<span className="span-element">*</span>
                  </div>
                  <FloatingLabelDatePicker
                    onChange={handleEffectiveDateChange}
                    defaultValue={inputValues.effectiveDate.value}
                    enableCreate={EnableCreate}
                    fieldType="effective"
                  />
                </div>
                {inputValues.effectiveDate.showError && (
                  <div
                    className="error-msg"
                    style={{
                      position: "relative",
                      top: "13px",
                    }}
                  >
                    {inputValues.effectiveDate.errorMsg}
                  </div>
                )}
              </div>
              {inputValues.effectiveDate.value && (
                <div
                  className={`date-sub-container ${
                    inputValues.expirationDate.showError
                      ? " validation-error-input"
                      : ""
                  }`}
                >
                  <div className="input-subContainer">
                    <div
                      className="label-element"
                      style={{ padding: "8px 0 0 10px" }}
                    >
                      Expiration Date<span className="span-element">*</span>
                    </div>
                    <FloatingLabelDatePicker
                      onChange={handleExpirationDateChange}
                      defaultValue={inputValues.expirationDate.value}
                      enableCreate={EnableCreate}
                      fieldType="expiration"
                      minDate={dayjs(inputValues.effectiveDate.value)}
                    />
                  </div>
                  {inputValues.expirationDate.showError && (
                    <div
                      className="error-msg"
                      style={{
                        position: "relative",
                        top: "13px",
                      }}
                    >
                      {inputValues.expirationDate.errorMsg}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="input-container" style={{ height: "auto" }}>
              <div className="input-subContainer">
                <label className="label-element">Files</label>
                <div onClick={handleAttachClick}>
                  <input
                    id="fileInput"
                    type="file"
                    className="modal-input-element"
                    style={{ display: "none" }}
                    multiple
                    onChange={(e) => handleFileUpload(e)} // allow multiple files
                  />
                  <div className="attach-document-container">
                    <span className="attach-span">Attach</span>
                    <img src={attach} alt="" />
                  </div>
                </div>
                <div>
                  <div className="file-container">
                    {EnableCreate ? (
                      fileNames.map((fileName, index) => (
                        <div key={index} className="file-list-container">
                          <span className="file-data">{fileName}</span>
                          <img
                            src={CrossClose}
                            alt=""
                            onClick={() => handleRemoveFile(fileName)}
                          />
                        </div>
                      ))
                    ) : (
                      <>
                        {newFiles.map((item: any, index: number) => {
                          return (
                            <div key={index} className="file-list-container">
                              <span className="file-data">
                                {item.fileName || item.name}
                              </span>
                              <img
                                src={CrossClose}
                                alt="removeIcon"
                                onClick={() =>
                                  handleRemoveFile(item.fileName || item.name)
                                }
                              />
                            </div>
                          );
                        })}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {fileError && <div className="error-msg">{fileErrorMsg}</div>}
          </div>
          <div className="modal-footer create-footer">
            <button className="popup-create-btn" onClick={() => handleSubmit()}>
              {EnableCreate ? "Create" : "Update"}
              {isLoading ? <Loader /> : <></>}
            </button>
            <button className="popup-Cancel-btn" onClick={handleModalClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CreateAndUpdate;
